import { ExportDestination, ExportFileFormats, ExportSource, ExportStatus } from "../main/constants/export.constants";

export default class Segment {
    constructor(Rest) {
        this.rest = Rest.rest;
    }

    all(page, paginate) {
        page = page || 1;
        paginate = (paginate != null) ? paginate : false;
        return this.rest.one('segmentation').get({ page: page, pagination: paginate });
    };

    fetchAllNew(page, per_page, search, pagination) {
        page = page || 1;
        per_page = per_page || 20;
        search = search || '';
        pagination = (pagination != null) ? pagination : false;
        return this.rest.one('segmentation').get({ page, per_page, search, pagination });
    };

    find(id) {
        return this.rest.one('segmentation', id).get();
    };

    store(name, description, tags) {
        return this.rest.all('segmentation').post({name: name, description: description, tags: tags});
    };

    findByName(name) {
        return this.rest.all('segmentation').one('findByName').one(name).getList();
    };

    searchFilters(search) {
        return this.rest.all('segmentation/search').post({ search: search });
    };

    updateName(id, name) {
        return this.rest.one('segmentation', id).put(data);
    };

    update(segment, withProgress, hidden, shouldSync) {
        if (shouldSync == null) {
            shouldSync = true;
        }

        withProgress = withProgress || false;
        hidden = hidden || segment.hidden;

        return this.rest.all('segmentation/' + segment.id).customPUT({
            structure: segment.structure,
            tags: segment.tags,
            description: segment.description,
            sync_at: segment.sync_at,
            subscriber_delete: segment.deleteSubscribersEnabled,
            name: segment.name,
            hidden: hidden,
            base_type: segment.based_on,
            withProgress: withProgress,
            shouldSync: shouldSync
        });
    };

    getExportById(id) {
        return this.rest.one('export', id).get();
    }

    getExportDownloadLink(id) {
        return this.rest.one('export', id).one('download').get();
    }

    exportToFile(data, exportActive, exportSuppressed) {
        return this.rest.all('export').post({
            source: ExportSource.Segment,
            destination: ExportDestination.File,
            segment: {
                id: data.filterId
            },
            export: {
                file_format: ExportFileFormats.Xls,
                export_active: exportActive,
                export_suppressed: exportSuppressed,
                custom_fields: data.fields.map(({ id }) => id).filter(Boolean)
            },
        });
    };

    countProgress(segmentId) {
        return this.rest.one('segmentation', segmentId).one('getCountProgress').customGET('', {}, {
            'accept': 'text/plain',
            'Content-Type': 'text/plain'
        });
    };

    removeExportFile(filePath) {
        return this.rest.all('temp_files/remove/export_file').post({ filePath: filePath });
    };

    countSubscribers(page) {
        page = page || 1;
        return this.rest.one('segmentation').one('countSubscribers').get({ page: page });
    };

    subscriberCount(id) {
        return this.rest.one('segmentation', id).one('countSubscribers').get({}, {'X-Partial' : true});
    };

    subscribers(attributes, page, view) {
        return this.rest.one('segmentation', attributes.segmentId).one('subscribers').get({
            page: page || 1,
            view: view || 'cards'
        });
    };

    search(search, page, view, attributes) {
        return this.rest.one('segmentation', attributes.segmentId).one('subscribers').one('search', search).get({
            page: page || 1,
            view: view || 'cards'
        });
    };

    destroy(segmentId) {
        return this.rest.one('segmentation', segmentId).remove();
    };

    deleteSubscribers(segmentId) {
        return this.rest.all('export').post({
            source: ExportSource.Segment,
            destination: ExportDestination.Trash,
            segment: {
                id: segmentId
            },
            export: {
                export_active: true,
                export_suppressed: true,
            },
        }).then((response) => this.checkExportProgress(response.data.id))
    };

    checkExportProgress(id) {
        let retries = 0

        const proceedProgress = (id) => {
            return this.getExportById(id).then(async (progress) => {
                retries += 1;

                if (progress.data.status.value === ExportStatus.Finished) {
                    return true
                }

                if (retries < 10) {
                    await new Promise(res => setTimeout(() => res(), 1000))

                    return proceedProgress(id);
                }

                throw new Error('Export failed')
            })
        }

        return proceedProgress(id);
    }

    copy(segmentId) {
        return this.rest.one('segmentation', segmentId).one('copy').get();
    };

    getDispatchers(dispatcherType) {
        return this.rest
            .all(`segmentation/dispatchers/${dispatcherType}`)
            .customGET("");
    };

    getDispatcherLinks(dispatcherType, dispatcherId) {
        return this.rest.all(`segmentation/dispatchers/${dispatcherType}/${dispatcherId}/links`).customGET("");
    }
};

Segment.$inject = ['Rest'];
